module.exports = __webpack_public_path__ + "img/bag.530c9611.svg";